<template>
<div class="auth-manage-wrap">
    <transition :name="transition" v-if="showShare">
      <div v-if="!loadSuccess" class="error-view">
        <svg-icon icon-class="error-load" class="error-icon"></svg-icon>
        <span>{{$t("加载失败，请刷新后重试#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1")}}</span>
        <div class="error-refresh-btn" @click="reload">{{$t("刷新#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1")}}</div>
      </div>
      <div v-else :class="['popover-share', isMettingDoc ? 'popover-share-meeting' : '']">
        <div class="share-view" v-if="!showAddAuthView">
          <div class="popover-share-content">
            <div class="popover-share-top">
              <div class="popover-share-top-title">
                <div class="title">                    {{myAuth === 'ALL' || (myAuth === 'WRITE' && isFileOwner)
  ? $t('权限管理#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1')
  : $t('查看协作者#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1')}}                </div>
                <div class="recover-content" v-show="(myAuth === 'ALL' || (myAuth === 'WRITE' && isFileOwner)) && !inheritedAuth">
                    <div class="recover-title">{{$t("已单独设置权限，其他页面修改权限不影响本页面#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1")}}                    </div>
                    <div class="recover-btn" @click.stop="recoverAuth">{{$t("恢复#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1")}}                    </div>
                </div>
              </div>
              <div class="set-and-close">
                <FileShareCopySetting v-if="isShowCopySetting" :fileId="fileId"></FileShareCopySetting>
                <div class="close-btn" @click.stop="closeShareView">
                    <img src="@/assets/h5/file/icon_file_close.png">
                </div>
              </div>
            </div>

            <div class="popover-share-center">
              <div class="popover-share-center-top">
                <div class="popover-share-center-top-title">
                  {{ topTitle }}
                </div>
                <!-- <div v-if="myAuth === 'ALL'" class="popover-share-center-top-btn" @click="enterManagerView">
                  <img src="@/assets/h5/file/icon_file_add_worker.png" />
                  {{ addWorkTitle }}
                </div> -->
                <div v-if="myAuth !== 'ALL'" class="apply-auth-btn" @click="applyMoreAuth">{{$t("申请更多权限#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1")}}                </div>
              </div>

              <div v-if="myAuth === 'ALL'" ref="inputContainer" class="popover-share-search" @mouseenter="hoverInput(true)" @mouseleave="hoverInput(false)">
                <div class="member-input">
                  <div ref="searchInput" class="search-input" contenteditable="true" @input="searchMembers" :data-placeholder="$t('搜索用户添加权限#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1')" @focus="searchInputFocus" @blur="handleBlur" @keydown="handleKeyDown"></div>
                  <FileShareSearchView v-show="showSearchResult" :searchText="searchText" :originData="shareList" @selectMember="selectMember"></FileShareSearchView>
                  <div v-show="searchText" class="clear-btn" @click.stop="clearText">
                    <svg-icon icon-class="file-transfer-input-clear" class="clear-icon"></svg-icon>
                  </div>
                </div>

                <moo-tooltip effect="light" placement="bottom" :content="$t('添加协作者#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1')" popper-class="share-manage-tooltip-class" :visible-arrow="false">
                  <div class="popover-share-search-add-member-btn" @click="enterManagerView">
                    <svg-icon icon-class="share-add-member" style="width: 16px; height: 16px;"></svg-icon>
                  </div>
                </moo-tooltip>
              </div>

              <div :class="[
                  'popover-share-center-worker',
                  isMettingDoc ? 'popover-share-center-worker-meeting' : '',
                ]">
                <FileShareManageView :isWiki="isWiki" :fileId="fileId" :myAuth="myAuth" :nonAdminMaxAuth="currentNonAdminMaxAuth" :shareAuthList="shareList" :userInfo="userInfo" @updateMemberAuthList="updateMemberAuthList"></FileShareManageView>
              </div>
              <div v-if="!isMettingDoc" style="width: 100%;">
                <div class="popover-share-center-title">{{$t("链接分享范围#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1")}}                    <moo-tooltip slot="reference" effect="light" :content="$t('已分配权限的协作者，无论链接分享范围如何设置，均按已分配的权限访问。#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1')" placement="top-start" popper-class="share-link-range-class">
                        <span class="share-tip-entry"><svg-icon icon-class="greyTips"></svg-icon></span>
                    </moo-tooltip>
                </div>
                <div id="link_share_range_set_share_view"></div>
              </div>
            </div>
          </div>

          <div class="popover-share-bottom">
            <div class="popover-share-bottom-copy-btn" @click="getShareUrl">
              <img src="@/assets/h5/file/icon_file_copy_link.png">{{$t("复制链接#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1")}}            </div>
          </div>
        </div>

        <FileShareAddConfirmView v-if="showAddAuthView" :myAuth="myAuth" :fileId="fileId" :nonAdminMaxAuth="currentNonAdminMaxAuth" :spaceId="userInfo.spaceId" :addData="shouldAddData" :originData="shareList" :isMettingDoc="isMettingDoc" :contentType="contentType" @backToManageView="backFromManageView"></FileShareAddConfirmView>
        <div id="invite-view-container" v-if="inManagerView"></div>
      </div>
    </transition>
    <div ref="popoverSlot">
      <slot name="reference"></slot>
    </div>
    <moo-dialog :top="isPcMode ? '35vh' : '35vh'" custom-class="cloud-common-dialog" :visible.sync="showRecoverDialog" :modal-append-to-body="false" :append-to-body="true" :width="isPcMode ? '448px' : '84%'" @closed="showRecoverDialog = false">
      <div v-if="isPcMode">
        <div class="title">
          <svg-icon class-name="dialog-icon" icon-class="file-warning"></svg-icon>{{$t("权限变更#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1")}}        </div>
        <div class="content">{{$t("恢复后，当前页面权限会和父页面保持一致，此后父页面的新增、删除、修改权限，均会影响到本页面，是否继续？#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1")}}        </div>
        <div class="footer">
          <div class="custom-button link-button" @click="showRecoverDialog = false">{{$t("取消#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1")}}          </div>
          <div class="custom-button reconnect-button" @click="recoverConfirm">{{$t("确认#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1")}}          </div>
        </div>
      </div>
      <div class="mobile-content" v-else>
        <div class="title">{{$t("权限变更#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_2")}}</div>
        <div class="content" :style="{ 'padding-left': '0px' }">{{$t("恢复后，当前页面权限会和父页面保持一致，此后父页面的新增、删除、修改权限，均会影响到本页面，是否继续？#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_2")}}        </div>
        <div class="footer" :style="'justify-content: space-evenly;'">
          <div class="custom-button" @click="showRecoverDialog = false">{{$t("取消#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_2")}}          </div>
          <div class="custom-button reconnect-button" :style="'margin-left: 0px;'" @click="recoverConfirm">{{$t("确认#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_2")}}          </div>
        </div>
      </div>
    </moo-dialog>
  </div>
</template>

<script>
import {
  getShareInfo,
  getShareUrl,
  getShareAuthList,
  deleteAuth,
  recoverAuth,
  nonAdminMaxAuth } from
"@/api/h5/file";
import FileShareAvatar from "./FileShareAvatar";
import FileShareManageView from "./FileShareManageView";
import FileShareAddConfirmView from "./FileShareAddConfirmView";
import FileShareSearchView from "./FileShareSearchView";
import buried from "@/pages/H5/Cloud/utils/buried/index";
import { useI18n, intl } from "tci18n-vue2";
import { mapState, mapActions } from "vuex";
import cookies from "js-cookie";
import { getShareAuthTip, mountAuthManagerLinkShareRangeSet } from './shareUtil';
import FileShareCopySetting from './FileShareCopySetting.vue';

export default {
  name: "FileShareView",
  components: {
    FileShareAvatar,
    FileShareManageView,
    FileShareAddConfirmView,
    FileShareSearchView,
    FileShareCopySetting
  },
  props: {
    transition: {
      type: String,
      default: "fade-in-linear"
    },
    showShare: {
      type: Boolean,
      default: false
    },
    reference: {},
    rightOffset: {
      type: Number,
      default: 0
    },
    fileId: {
      type: String,
      default: "",
      required: true
    },
    fileUrl: {
      type: String,
      default: "",
      required: true
    },
    myAuth: {
      type: String
    },
    userInfo: {
      type: Object
    },
    sameSpace: {
      type: Boolean
    },
    isWiki: {
      type: Boolean,
      default: false
    },
    isFileOwner: {
      type: Boolean
    },
    isMettingDoc: {
      type: Boolean,
      default: false
    },
    contentType: {
      type: String,
      default: ""
    }
  },
  watch: {
    myAuth: {
      handler(v) {
        if (v === "ALL") {
          this.addWorkTitle = intl.$t("添加协作者#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_2");
        }
        this.initData();
        this.queryNonAdminMaxAuth();
      }
    },
    showShare: {
      handler(v) {
        if (v === false) {
          this.inManagerView = false;
          this.searchText = "";
          if (this.linkShareRangeSet) {
            this.linkShareRangeSet.destroy();
            this.linkShareRangeSet = null;
          }
        } else {
          this.initData();
          this.queryNonAdminMaxAuth();
          this.$nextTick(() => {
            this.mountAuthManagerLinkShareRangeSet();
          });
        }
      }
    },
    showAddAuthView: {
      handler(v) {
        if (v === false) {
          this.initData();
          this.$nextTick(() => {
            this.mountAuthManagerLinkShareRangeSet();
          });
        }
      }
    },
    shareList: {
      handler(v) {
        if (v.length !== 0) {
          this.configUserAndDepartData(v);
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      popoverStyle: "",
      popoverWidth: 400,
      addWorkTitle: intl.$t("添加协作者#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_3"),
      shareAuth: "",
      shareScope: "",
      shareList: [],
      inManagerView: false,
      loadSuccess: false,
      inviteUsersList: [],
      disableUserList: [],
      selectDepartList: [],
      selectGroupList: [],
      selectImList: [],
      shouldAddData: [],
      showAddAuthView: false,
      inheritedAuth: true,
      showRecoverDialog: false,
      shareUrl: null,
      searchText: "",
      isFocus: false,
      selectedMember: null,
      showSearchResult: true,
      currentNonAdminMaxAuth: "",
      watermarkText: "",
      spaceInfo: null,
      shareExpireDate: null,
      sharePassword: '',
      linkShareRangeSet: null,
      canUpdateUrlAuth: false
    };
  },
  computed: {
    ...mapState({
      isPcMode: (state) => state.isPcMode,
      shareAuthTip: (state) => state.shareAuthTip,
      cloudI18n: (state) => state.cloudI18n,
      wikiSpaceInfo: (state) => state.wikiSpaceInfo
    }),
    locale() {
      return this.cloudI18n || localStorage.getItem("tci18nLocale") || navigator.language || "zh-cn";
    },
    topTitle() {
      if (this.shareScope === 'COLLABORATOR') {
        return intl.$t("仅以下协作者可查看/编辑#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1");
      }
      return this.myAuth !== "ALL" ? intl.$t("协作者#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1") : intl.$t("邀请协作者#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1");
    },
    isShowCopySetting() {
      if (
      this.myAuth === 'ALL' && (
      this.contentType === 'DOCUMENT' ||
      this.contentType === 'EXCEL' ||
      this.contentType === 'PPT' ||
      this.contentType === 'PDF' ||
      this.contentType === 'WORD'))
      {
        return true;
      }
      return false;
    },
    isChinese() {
      const { lang } = useI18n();
      return lang === "zh-cn";
    }
  },
  mounted() {
    this.initData();
    document.addEventListener("visibilitychange", this.handleVisibilityChange);
  },
  unmounted() {
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
    if (this.linkShareRangeSet) {
      this.linkShareRangeSet.destroy();
      this.linkShareRangeSet = null;
    }
  },
  methods: {
    ...mapActions(["setShareAuthTip"]),
    updateShareInfo(auth, scope, fileId) {
      this.shareAuth = auth;
      this.shareScope = scope;
      if (this.linkShareRangeSet) {
        this.linkShareRangeSet.updateShareRangeInfo(auth, scope, this.shareExpireDate, this.sharePassword, this.spaceInfo, this.watermarkText);
      }
      const tip = getShareAuthTip(auth, scope, this.spaceInfo);
      this.setShareAuthTip(tip);
    },
    UpdateLinkShareRangeSet(val) {
      if (this.linkShareRangeSet) {
        this.linkShareRangeSet.UpdateLinkShareRangeSet(val);
      }
    },
    mountAuthManagerLinkShareRangeSet() {
      this.linkShareRangeSet = mountAuthManagerLinkShareRangeSet(
        '#link_share_range_set_share_view',
        this.isWiki,
        this.locale,
        this.fileId,
        this.canUpdateUrlAuth,
        (auth, scope, expireDate, password, spaceInfo, shareAuthTip) => {
          this.$emit('updateLinkShareRange', auth, scope, expireDate, password, spaceInfo, shareAuthTip);
        },
        (tip) => {
          this.setShareAuthTip(tip);
        },
        (domId, visible) => {
          this.$emit('onLinkRangeSetDropdownVisible', domId, visible);
        }
      );
    },
    handleVisibilityChange() {
      if (
      document.hidden &&
      this.$refs.searchInput &&
      this.$refs.searchInput === document.activeElement)
      {
        this.$refs.searchInput.blur();
      }
    },
    /// 初始化信息
    initData() {
      // 链接分享 - 获取链接分享信息
      this.getShareInfo();
      this.queryNonAdminMaxAuth();
    },
    /// 链接分享 - 获取链接分享信息
    async getShareInfo() {
      try {
        const res = await getShareInfo(this.fileId);
        const { code, data, message } = res;
        // console.log('获取分享信息', res);
        if (code === 200) {
          if (data === null || data === undefined) {
            // 查询文件协作者列表
            this.queryShareAuthList();
            return;
          }
          const {
            auth,
            scope,
            expireDate,
            password,
            watermarkText,
            spaceInfo,
            memberAcl
          } = data;
          this.shareAuth = auth;
          this.shareScope = scope;
          this.watermarkText = watermarkText;
          this.spaceInfo = spaceInfo;
          this.shareExpireDate = expireDate;
          this.sharePassword = password;
          this.canUpdateUrlAuth = memberAcl?.canUpdateUrlAuth;

          this.$emit('UpdateLinkShareRangeSet', this.canUpdateUrlAuth);
          this.$emit('updateLinkShareRange', auth, scope, expireDate, password, spaceInfo, watermarkText);
          if (this.linkShareRangeSet) {
            this.linkShareRangeSet.updateShareRangeInfo(auth, scope, expireDate, password, spaceInfo, watermarkText);
            this.linkShareRangeSet.UpdateLinkShareRangeSet(this.canUpdateUrlAuth);
          }

          // 设置tip
          const tip = getShareAuthTip(auth, scope, spaceInfo);
          this.setShareAuthTip(tip);
          // 查询文件协作者列表
          this.queryShareAuthList();
        } else {
          this.loadSuccess = false;
        }
      } catch (error) {
        this.loadSuccess = false;
      }
    },
    queryNonAdminMaxAuth() {
      nonAdminMaxAuth(this.fileId).
      then((res) => {
        const { code, data, message } = res || {};
        if (code === 200 && data !== null) {
          this.currentNonAdminMaxAuth = data;
        }
      }).
      catch((error) => {});
    },
    /// 查询文件协作者列表
    async queryShareAuthList() {
      const fileId = this.fileId;
      getShareAuthList(fileId).
      then((res) => {
        const { code, data, message } = res || {};
        // console.log('获取文件协作者列表：', res);
        if (code === 200 && data !== null) {
          const { inheritedAuth, authInfos, shareUrl } = data;
          this.inheritedAuth = inheritedAuth;
          this.shareList = authInfos;
          this.$emit('updateAuthInfos', authInfos);
          this.loadSuccess = true;
        } else {
          this.loadSuccess = false;
        }
      }).
      catch((error) => {
        this.loadSuccess = false;
      });
    },
    updateMemberAuthList() {
      this.queryShareAuthList();
    },
    /// 申请更多权限
    applyMoreAuth() {
      this.closeShareView();
      this.$emit("applyAuth");
    },
    /// 关闭分享视图
    closeShareView() {
      this.$emit("closeShareView", false);
    },
    /// 管理/查看协作者
    enterManagerView() {
      this.inManagerView = !this.inManagerView;
      if (this.inManagerView) {
        buried.reportPoint("添加协作者", "add_mermbers");
      }
      let that = this;
      setTimeout(async () => {
        await import("@toca/toca-finder/dist/style.css");
        const { TocaFinder } = await import("@toca/toca-finder");

        const params = {
          locale: that.cloudI18n,
          envConfig: process.env.VUE_APP_STATIC_NODE_ENV,
          selectTitle: intl.$t("添加协作者#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_4"),
          confirmTitle: intl.$t("下一步#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1"),
          maxNum: 9999,
          maxNumNotiy: intl.$t("协作者人数已达上限#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1"),
          showUserGroup: true,
          confirmEmpty: false,
          showIMGroup: true,
          selectImList: that.selectImList,
          isShowUnitedSpaces: true,
          selectGroupList: that.selectGroupList,
          selectUserList: that.inviteUsersList,
          selectUsersDisabled: that.disableUserList,
          selectDepartList: that.selectDepartList,
          closeOnClickModal: false,
          show: that.inManagerView,
          modal: true,
          checkStrictly: true,
          userId: cookies.get("userId") || "",
          spaceId: cookies.get("spaceId") || "",
          token: cookies.get("token") || "",
          deviceId: cookies.get("deviceId") || "",
          memberId:
          cookies.get("memberUniqueId") || cookies.get("memberId") || "",
          handerConfirmCallback: that.inviteConfirm,
          handerCloseCallback: that.closeInviteView
        };
        that.tocaFinder = new TocaFinder("#invite-view-container", params);
      }, 0);
    },
    backToShareView() {
      this.inManagerView = false;
    },
    /// 获取分享链接
    getShareUrl() {
      buried.reportPoint("复制链接", "copy_url");
      this.createCopyArea(this.fileUrl);
    },
    createCopyArea(url) {
      navigator.clipboard.
      write([
      new ClipboardItem({
        "text/plain": new Blob([url], { type: "text/plain" })
      })]
      ).
      then(() => {
        // console.log("HTML copied to clipboard");
        if (this.shareScope === 'COLLABORATOR') {
          this.$message({
            message: intl.$t("链接已复制，仅协作者可查看，请确认对方是否为协作者#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1"),
            type: "success"
          });
        } else {
          const tip = getShareAuthTip(this.shareAuth, this.shareScope, this.spaceInfo, false);
          this.$message({ message: intl.$t(`链接已复制，{tip}#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1`, { tip: tip }), type: "success" });
        }
      }).
      catch((err) => {
        console.error("Failed to copy HTML: ", err);
        this.$message({ message: intl.$t("链接复制失败#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1"), type: "error" });
      });
    },
    reload() {
      this.initData();
    },
    backFromManageView() {
      this.updateMemberAuthList();
      this.showAddAuthView = !this.showAddAuthView;
    },
    configUserAndDepartData(originData) {
      // console.log('当前数组：', originData);
      this.disableUserList = [];
      this.selectDepartList = [];
      this.inviteUsersList = [];
      this.selectGroupList = [];
      this.selectImList = [];
      originData.forEach((item) => {
        if (
        item.edit === false ||
        item.memberIdentity === "ADMIN" ||
        item.memberIdentity === "MEMBER")
        {
          if (item.toType === "PERSON") {
            this.disableUserList.push({
              userId: item.to,
              type: 0,
              spaceId: item.toSpace,
              memberName: item.toName,
              memberAvatar: item.toAvatar,
              spaceName: item.toSpaceName
            });
          } else {
            this.disableUserList.push({
              departmentId: item.to,
              type: 1,
              spaceId: item.toSpace,
              departmentName: item.toName,
              spaceName: item.toSpaceName
            });
          }
        }
        if (item.toType === "DEPARTMENT") {
          this.selectDepartList.push({
            departmentId: item.to,
            type: 1,
            spaceId: item.toSpace,
            departmentName: item.toName,
            spaceName: item.toSpaceName
          });
        }
        if (
        item.toType === "PERSON" &&
        item.memberIdentity !== "ADMIN" &&
        item.memberIdentity !== "MEMBER" &&
        item.edit)
        {
          this.inviteUsersList.push({
            userId: item.to,
            type: 0,
            spaceId: item.toSpace,
            memberName: item.toName,
            memberAvatar: item.toAvatar,
            spaceName: item.toSpaceName
          });
        }
        if (item.toType === "USER_GROUP") {
          this.selectGroupList.push({
            type: 2,
            name: item.toName,
            description: item.toName,
            ...item,
            id: item.to
          });
        }

        if (item.toType === "GROUP") {
          this.selectImList.push({
            type: 3,
            avatar: item.toAvatar,
            chatAvatar: item.toAvatar,
            chatName: item.toName,
            name: item.toName,
            ...item,
            id: item.to
          });
        }
      });
    },
    async inviteConfirm(addData, allData, reduceData) {
      if (addData.length === 0 && reduceData.length === 0) {
        this.inManagerView = false;
        return;
      }
      if (reduceData.length > 0) {
        for (const { type, userId, departmentId, id, spaceId } of reduceData) {
          let to = "";
          switch (type) {
            case 0:
              to = userId;
              break;
            case 1:
              to = departmentId;
              break;
            case 2:
              to = id;
              break;
            case 3:
              to = id;
              break;
          }
          const member = this.shareList.find((item) => {
            if (type !== 2 && type !== 3) {
              return item.to === to && item.toSpace === spaceId;
            } else {
              return item.to === to;
            }
          });
          if (member == null) continue;
          await deleteAuth(
            member.to,
            false,
            this.fileId,
            member.toSpace,
            member.toType
          );
        }
        this.updateMemberAuthList();
      }

      if (addData.length > 0) {
        this.shouldAddData = addData;
        this.showAddAuthView = true;
      }
    },
    closeInviteView() {
      this.inManagerView = false;
    },
    recoverAuth() {
      this.showRecoverDialog = true;
    },
    recoverConfirm() {
      recoverAuth(this.fileId).
      then((res) => {
        const { code, message } = res || {};
        if (code === 200) {
          this.$message({ message: intl.$t("权限恢复成功#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1"), type: "success" });
          this.updateMemberAuthList();
          this.showRecoverDialog = false;
        } else {
          this.$message({
            message: intl.$t(`权限恢复失败，{message}#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1`, { message: message }),
            type: "error"
          });
        }
      }).
      catch((err) => {
        this.$message({ message: intl.$t(`权限恢复失败，请重试#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1`), type: "error" });
      });
    },
    hoverInput(isHover) {
      if (isHover) {
        this.inputContainerBorderStyle(true);
      } else {
        if (!this.isFocus) {
          this.inputContainerBorderStyle(false);
        }
      }
    },
    selectMember(item) {
      this.showSearchResult = false;
      this.selectedMember = item;
      this.$refs.searchInput.innerText = this.searchText = "";
      this.inputContainerBorderStyle(false);
      this.isFocus = false;

      let isOwner = false;
      let isAdmin = false;
      let exsitMember = this.shareList.find((member) => {
        if (
        member.toSpace === item.spaceId &&
        member.to === item.userId && (
        member.memberIdentity === "ADMIN" ||
        member.memberIdentity === "OWNER"))
        {
          if (member.memberIdentity === "ADMIN") {
            isAdmin = true;
          } else if (member.memberIdentity === "OWNER") {
            isOwner = true;
          }
        }
        return member.toSpace === item.spaceId && member.to === item.userId;
      });

      if (exsitMember) {
        if (isOwner) {
          this.$message.warning(intl.$t("该用户为文档所有者，请勿重复添加#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1"));
          return;
        } else if (isAdmin) {
          this.$message.warning(intl.$t("该用户为管理员，请勿重复添加#!!!#src/pages/H5/Cloud/components/share/FileShareView.vue_1"));
          return;
        }
      }
      this.shouldAddData = [];
      let defaultAuth = "READ_DOWNLOAD";
      if (
      this.contentType === 'DOCUMENT' ||
      this.contentType === 'EXCEL' ||
      this.contentType === 'PPT' ||
      this.contentType === 'PDF' ||
      this.contentType === 'WORD') {
        defaultAuth = 'READ';
      }
      this.shouldAddData.push({
        memberName: item.memberName,
        memberAvatar: item.memberAvatar,
        memberUniqueId: item.id,
        spaceId: item.spaceId,
        type: 0,
        userId: item.userId,
        spaceName: item.spaceName,
        auth: exsitMember ? exsitMember.auth : defaultAuth
      });
      this.showAddAuthView = true;
    },
    searchMembers(event) {
      this.selectedMember = null;
      this.showSearchResult = true;
      this.searchText = event.target.innerText;
    },
    searchInputFocus() {
      this.isFocus = true;
      this.inputContainerBorderStyle(true);
      this.handleRange();
    },
    handleRange() {
      this.$nextTick(() => {
        const range = document.createRange();
        const sel = window.getSelection();
        this.$refs.searchInput.focus();
        const childNodes = this.$refs.searchInput.childNodes;
        if (childNodes.length > 0) {
          const lastNode = childNodes[childNodes.length - 1];
          range.setStart(lastNode, lastNode.length || 0);
          range.collapse(true);
          sel?.removeAllRanges();
          sel?.addRange(range);
        }
      });
    },
    handleBlur() {
      this.isFocus = false;
      if (this.searchText) {
        this.inputContainerBorderStyle(false);
        setTimeout(() => {
          this.showSearchResult = false;
        }, 200);
      } else {
        this.inputContainerBorderStyle(false);
      }
    },
    handleKeyDown(event) {
      if (event.key === "Enter") {
        event.preventDefault();
      }
    },
    clearText() {
      this.$refs.searchInput.innerText = this.searchText = "";
      this.$refs.searchInput.focus();
    },
    inputContainerBorderStyle(hasBorder) {
      if (hasBorder) {
        this.$refs.inputContainer.style.border = "1px solid #5C70FF";
      } else {
        this.$refs.inputContainer.style.border = "1px solid #A2A4B0";
      }
    }
  },
  destory() {},
  beforeDestroy() {
    document.removeEventListener(
      "visibilitychange",
      this.handleVisibilityChange
    );
  }
};
</script>

<style lang="scss" scoped>
.auth-manage-wrap {
  position: relative;
}

#link_share_range_set_share_view {
  max-height: 210px;
  overflow-y: scroll;

  &::-webkit-scrollbar {
    display: none;
  }
}

.error-view {
  position: absolute;
  top: 32px;
  right: 0;
  width: 400px;
  z-index: 2000;
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid #e6e8ec;
  box-shadow: 0 8px 12px 0 #1213171a;
  box-sizing: border-box;
  min-height: 312px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .error-icon {
    width: 108px;
    height: 108px;
    margin-bottom: 17px;
  }

  span {
    color: #a2a4b0;
    font-size: 14px;
    font-family: "PingFang SC", sans-serif;
    font-weight: 400;
    line-height: auto;
    letter-spacing: 0;
    text-align: center;
  }

  .error-refresh-btn {
    color: #5c70ff;
    font-size: 14px;
    font-family: "PingFang SC", sans-serif;
    font-weight: 400;
    line-height: auto;
    letter-spacing: 0;
    text-align: center;
    cursor: pointer;
  }
}

.popover-share-meeting {
  min-height: 261px !important;
}

.popover-share {
  position: absolute;
  z-index: 2000;
  top: 32px;
  right: 0;
  width: 400px;
  background-color: #fff;
  border-radius: 10px;
  border: 1px solid #e6e8ec;
  box-shadow: 0 8px 12px 0 #1213171a;
  box-sizing: border-box;
  min-height: 312px;
  display: flex;
  flex-direction: column;

  .share-view {
    display: flex;
    flex-direction: column;

    .popover-share-content {
      display: flex;
      flex-direction: column;
      flex: 1;
      margin: 16px 16px 0px 16px;

      .popover-share-top {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        line-height: 100%;
        margin-bottom: 24px;

        .popover-share-top-title {
          display: flex;
          flex: 1;
          flex-direction: column;

          .title {
            font-size: 16px;
            font-weight: 600;
            color: #121317;
            line-height: 24px;
          }

          .recover-content {
                margin-top: 8px;
                height: 34px;
                padding: 0 12px;
                border-radius: 8px;
                background: #eceeff;
                display: flex;
                flex: 1;
                flex-direction: row;
                align-items: center;
                justify-content: space-between;
                box-shadow: none;
                border: none;

                .recover-title {
                    margin: 7px 0px;
                    color: #646a73;
                    font-size: 14px;
                    font-weight: 400;
                    line-height: 20px;
                }

                .recover-btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    height: 20px;
                    padding: 0 2px;
                    border-radius: 6px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #5d71ff;
                    background-color: #ffffff;
                    letter-spacing: 0;
                    cursor: pointer;
                }
            }
        }

        .set-and-close {
            position: absolute;
            right: 0px;
            top: 0px;
            display: flex;
            flex-direction: row;
            .close-btn {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 24px;
                height: 24px;
                cursor: pointer;

                img {
                    width: 14px;
                    height: 14px;
                    object-fit: contain;
                }

                &:hover {
                    background-color: #f4f6f9;
                    border-radius: 4px;
                }
            }
        }
      }

      .popover-share-center {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
        margin-bottom: 24px;

        .popover-share-center-top {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          margin-bottom: 16px;

          .popover-share-center-top-title {
            display: flex;
            flex: 1;
            font-size: 14px;
            font-weight: 500;
            font-family: PingFangSC-Medium;
            color: #323233;
            line-height: 20px;
          }

          .popover-share-center-top-btn {
            cursor: pointer;
            font-size: 14px;
            font-weight: 300;
            font-family: PingFangSC-Regular;
            line-height: 20px;
            color: #5d71ff;
            display: flex;
            align-items: center;
            justify-content: center;
            padding: 2px 8px;

            img {
              width: 12px;
              height: 12px;
              margin-right: 4px;
            }

            &:hover {
              background-color: #f4f6f9;
              border-radius: 6px;
            }
          }

          .apply-auth-btn {
            border-radius: 6px;
            padding: 2px 8px;
            background-color: #ffffff;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #5d71ff;
            letter-spacing: 0;
            cursor: pointer;

            &:hover {
              background-color: #f5f6f7;
            }
          }
        }

        .popover-share-search {
          margin-bottom: 8px;
          width: 100%;
          height: 32px;
          box-sizing: border-box;
          border: 1px solid #A2A4B0;
          border-radius: 6px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;

          .member-input {
            width: 100%;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            position: relative;

            .search-input {
              display: inline-flex;
              flex: 1;
              padding: 6px 12px;
              background: transparent;
              border: none;
              font-family: PingFangSC-Regular;
              font-weight: 400;
              font-size: 14px;
              line-height: 20px;
              color: #121317;
              text-align: left;

              &:empty::before {
                content: attr(data-placeholder);
                font-family: PingFangSC-Regular;
                font-weight: 400;
                font-size: 14px;
                color: #8f959e;
                letter-spacing: 0;
                line-height: 20px;
                cursor: text;
              }

              &:focus-visible {
                outline: none;
              }
            }

            .clear-btn {
              width: 16px;
              height: 16px;
              padding-right: 12px;
              display: flex;
              cursor: pointer;

              .clear-icon {
                width: 16px;
                height: 16px;
              }
            }
          }

          .popover-share-search-add-member-btn {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 30px;
            height: 30px;
            cursor: pointer;
            border-left: 1px solid #A2A4B0;
            border-radius: 0 6px 6px 0;

            img {
              width: 16px;
              height: 16px;
            }

            &:hover {
              background: #edeeee;
            }
          }
        }

        .popover-share-center-worker-meeting {
          margin-bottom: 0px !important;
        }

        .popover-share-center-worker {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: flex-start;
          width: 100%;
          min-height: 40px;
          max-height: 325px;
          margin-bottom: 24px;

          &::-webkit-scrollbar {
            display: none;
          }
        }

        .popover-share-center-title {
          font-size: 14px;
          font-weight: 500;
          font-family: PingFangSC-Medium;
          color: #323233;
          line-height: 20px;
          margin-bottom: 16px;

          .share-tip-entry {
            cursor: pointer;
            width: 12px;
            height: 12px;
          }
        }

      }
    }

    .popover-share-bottom {
      height: 52px;
      width: 100%;
      background-color: #f5f6f7;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      border-radius: 0 0 10px 10px;

      .popover-share-bottom-copy-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 16px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 300;
        font-family: PingFangSC-Regular;
        color: #fff;
        line-height: 20px;
        background-color: #5c70ff;
        width: 100px;
        height: 36px;
        border-radius: 8px;

        img {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }

        &:hover {
          background-color: #6d7dff;
        }
      }
    }
  }
}

.moo-popper {
  margin-top: 10px !important;
  margin-left: 34px !important;
  padding: 4px 0px !important;
  background: #ffffff !important;
  border: 1px solid #e6e8ec !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border-radius: 8px !important;
  width: 270px !important;
}

.moo-dropdown-menu__item {
  height: 28px !important;
  padding: 0 0 !important;
  margin: 4px 4px !important;
  display: flex !important;
  flex-direction: row !important;
  align-items: center !important;
  justify-content: flex-start !important;
  font-size: 14px !important;
  font-weight: 300 !important;
  font-family: PingFangSC-Regular !important;
  // line-height: 20px !important;
  color: #333333 !important;
  cursor: pointer;

  &:hover {
    background-color: #f4f6f9 !important;
    border-radius: 8px !important;
  }

  .share-scope-list-name {
    flex: 1;
    margin: 0 5px;
    line-height: 1 !important;
  }

  img {
    width: 15px;
    height: 11px;
    margin-right: 11px;
  }
}

.fade-in-linear-enter-active,
.fade-in-linear-leave-active {
  transition: opacity 200ms linear;
}

.fade-in-linear-enter,
.fade-in-linear-leave,
.fade-in-linear-leave-active {
  opacity: 0;
}
</style>

<style lang="scss">
@import "~@/styles/cloudCommonDialog.scss";

.share-manage-tooltip-class {
  border-radius: 8px !important;
  color: #767c85;
  font-size: 14px !important;
  font-weight: 400;
  padding: 8px !important;
  background-color: #fff !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border: none !important;
  height: 22px;
  line-height: 24px !important;
  margin-top: 8px !important;
  text-align: center !important;
}

.share-link-range-class {
  border-radius: 8px !important;
  color: #767c85 !important;
  font-size: 14px !important;
  font-weight: 400;
  padding: 8px !important;
  background-color: #fff !important;
  box-shadow: 0 8px 12px 0 #1213171a !important;
  border: none !important;
  width: 256px !important;
  line-height: 24px !important;
  margin-top: 13px !important;
  text-align: left !important;
}
</style>
